import { Locale } from './component';
import { Props } from './props';

export type LocaleProps = Props;
export * from './component';
export default Locale;
